
import { TranslationsByLanguage } from './types';

export type LicenseTranslationKey =
  | 'license.terms'
  | 'license.description'
  | 'license.requiredMentions'
  | 'license.requiredHashtags'
  | 'license.readFullTerms'
  | 'license.acceptTerms'
  | 'license.acceptTermsTitle'
  | 'license.downloadTermsDescription'
  | 'license.standardLicense'
  | 'license.permissions'
  | 'license.restrictions'
  | 'license.download'
  | 'license.downloadStarted'
  | 'license.downloadError'
  | 'license.acceptTermsRequired'
  | 'license.pleaseReviewTerms'
  | 'license.summary'
  | 'license.usage'
  | 'license.fullTerms'
  | 'share.via'
  | 'share.shareThisContent'
  | 'share.socialMedia'
  | 'common.copy'
  | 'common.copied'
  | 'common.copiedToClipboard'
  | 'common.mention'
  | 'common.hashtag'
  | 'common.pleaseWait'
  | 'common.requestedClipNotFound'
  | 'common.downloadingProgress'
  | 'common.preparing'
  | 'common.preparingDownload';

export const licenseTranslations: TranslationsByLanguage = {
  en: {
    'license.terms': 'License Terms',
    'license.description': 'Required attribution for using this content',
    'license.requiredMentions': 'REQUIRED MENTIONS',
    'license.requiredHashtags': 'REQUIRED HASHTAGS',
    'license.readFullTerms': 'Read Full Terms',
    'license.acceptTerms': 'I accept the terms and conditions',
    'license.acceptTermsTitle': 'Accept License Terms',
    'license.downloadTermsDescription': 'Please accept the license terms before downloading this content',
    'license.standardLicense': 'Standard license for social media usage',
    'license.permissions': 'Permissions',
    'license.restrictions': 'Restrictions',
    'license.download': 'Download',
    'license.downloadStarted': 'Download started!',
    'license.downloadError': 'Error during download',
    'license.acceptTermsRequired': 'Please accept the license terms before downloading',
    'license.pleaseReviewTerms': 'Please review the license terms before downloading',
    'license.summary': 'Summary',
    'license.usage': 'Usage Guidelines',
    'license.fullTerms': 'Full Terms',
    'share.via': 'Share',
    'share.shareThisContent': 'Share this content with your friends and followers',
    'share.socialMedia': 'Social Media',
    'common.copy': 'Copy',
    'common.copied': 'Copied',
    'common.copiedToClipboard': 'Copied to clipboard',
    'common.mention': 'Mention',
    'common.hashtag': 'Hashtag',
    'common.pleaseWait': 'Please wait while we load the clip details.',
    'common.requestedClipNotFound': 'The requested clip could not be found.',
    'common.downloadingProgress': 'Downloading progress',
    'common.preparing': 'Preparing',
    'common.preparingDownload': 'Preparing your download'
  },
  fr: {
    'license.terms': 'Conditions de Licence',
    'license.description': 'Attribution requise pour l\'utilisation de ce contenu',
    'license.requiredMentions': 'MENTIONS REQUISES',
    'license.requiredHashtags': 'HASHTAGS REQUIS',
    'license.readFullTerms': 'Lire les Conditions Complètes',
    'license.acceptTerms': 'J\'accepte les termes et conditions',
    'license.acceptTermsTitle': 'Accepter les Conditions de Licence',
    'license.downloadTermsDescription': 'Veuillez accepter les conditions de licence avant de télécharger ce contenu',
    'license.standardLicense': 'Licence standard pour l\'utilisation sur les réseaux sociaux',
    'license.permissions': 'Autorisations',
    'license.restrictions': 'Restrictions',
    'license.download': 'Télécharger',
    'license.downloadStarted': 'Téléchargement commencé!',
    'license.downloadError': 'Erreur lors du téléchargement',
    'license.acceptTermsRequired': 'Veuillez accepter les conditions de licence avant de télécharger',
    'license.pleaseReviewTerms': 'Veuillez examiner les conditions de licence avant de télécharger',
    'license.summary': 'Résumé',
    'license.usage': 'Guide d\'utilisation',
    'license.fullTerms': 'Conditions complètes',
    'share.via': 'Partager',
    'share.shareThisContent': 'Partagez ce contenu avec vos amis et abonnés',
    'share.socialMedia': 'Réseaux Sociaux',
    'common.copy': 'Copier',
    'common.copied': 'Copié',
    'common.copiedToClipboard': 'Copié dans le presse-papier',
    'common.mention': 'Mention',
    'common.hashtag': 'Hashtag',
    'common.pleaseWait': 'Veuillez patienter pendant le chargement des détails du clip.',
    'common.requestedClipNotFound': 'Le clip demandé n\'a pas été trouvé.',
    'common.downloadingProgress': 'Progression du téléchargement',
    'common.preparing': 'Préparation',
    'common.preparingDownload': 'Préparation de votre téléchargement'
  }
};
